export const isOldFIGPattern = (questionArray: string[]): boolean => {
  if (
    questionArray.includes('___GAP___' as Types.API.Question.FillInBlanksFieldType) ||
    questionArray.includes('___NEWLINE___' as Types.API.Question.FillInBlanksFieldType)
  )
    return false;

  return true;
};
